import { checkAndCacheAll } from './common'

export async function getFolders (fetchFunction) {
  return checkAndCacheAll('folders', fetchFunction)
}
